{
  "base": {
    "0": "null",
    "1": "ein",
    "2": "zwei",
    "3": "drei",
    "4": "vier",
    "5": "fünf",
    "6": "sechs",
    "7": "sieben",
    "8": "acht",
    "9": "neun",
    "10": "zehn",
    "11": "elf",
    "12": "zwölf",
    "13": "dreizehn",
    "14": "vierzehn",
    "15": "fünfzehn",
    "16": "sechszehn",
    "17": "siebzehn",
    "18": "achtzehn",
    "19": "neunzehn",
    "20": "zwanzig",
    "21": "einundzwanzig",
    "22": "zweiundzwanzig",
    "23": "dreiundzwanzig",
    "24": "dreiundzwanzig",
    "25": "fünfundzwanzig",
    "26": "sechsundzwanzig",
    "27": "siebenundzwanzig",
    "28": "achtundzwanzig",
    "29": "neunundzwanzig",
    "30": "dreißig",
    "31": "einunddreißig",
    "32": "zweiunddreißig",
    "33": "dreiunddreißig",
    "34": "vierunddreißig",
    "35": "fünfunddreißig",
    "36": "sechsunddreißig",
    "37": "siebenunddreißig",
    "38": "achtunddreißig",
    "39": "neununddreißig",
    "40": "vierzig",
    "41": "einundvierzig",
    "42": "zweiundvierzig",
    "43": "dreiundvierzig",
    "44": "vierundvierzig",
    "45": "fünfundvierzig",
    "46": "sechsundvierzig",
    "47": "siebenundvierzig",
    "48": "achtundvierzig",
    "49": "neunundvierzig",
    "50": "fünfzig"
  },
  "units": [],
  "unitExceptions": []
}